import { FornecedorInicial, FornecedorModel } from "../models/fornecedorModel"
import { DadosFornecedorActionModel, DadosFornecedorActionsTypes } from "./dadosFornecedorActions"

export function dadosFornecedorReducer(
    state: FornecedorModel,
    action: DadosFornecedorActionModel
): FornecedorModel {
    switch (action.type) {
        case DadosFornecedorActionsTypes.CARREGAR:
            return action.payload

        case DadosFornecedorActionsTypes.ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case DadosFornecedorActionsTypes.RESETAR:
            return FornecedorInicial

        default:
            return state
    }
}
